const state = {
	pendingAction: null,
};

const mutations = {
	SET_PENDING_ACTION(state, actionType) {
		state.pendingAction = actionType;
	},
};

const actions = {
	triggerAction({ commit }, actionType) {
		commit("SET_PENDING_ACTION", actionType);
	},
	clearPendingAction({ commit }) {
		commit("SET_PENDING_ACTION", null);
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
};
